import { useInfiniteQuery } from '@tanstack/react-query';
import ScheduleSection from './ScheduleSection';
import { teacherImageList } from '../../../constants/teacherImages';
import { teacherBadgeList } from '../../../constants/teacherBadges';

const TeacherSection = ({ id }) => {
    const API_URL = import.meta.env.VITE_API_URL;
    const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
        queryKey: ['teacherList', id],
        queryFn: async ({ pageParam = 1 }) => {
            const res = await fetch(`${API_URL}/bbs/ajax.get_teacher_list.php?cl_id=${id}&page=${pageParam}`);
            return res.json();
        },
        getNextPageParam: (lastPage) => {
            const currentPage = parseInt(lastPage.data.pagination.page, 10);
            const totalPage = parseInt(lastPage.data.pagination.total_page, 10);
            if (currentPage < totalPage) {
                return currentPage + 1;
            }
            return undefined;
        }
    });
    
    const items = (data?.pages.flatMap(page => page.data.list) ?? []).map((item) => ({ 
        ...item, 
        file: teacherImageList[item.name] || null,
        badge: teacherBadgeList[item.name] || null,
    }));

    return (
        <div className="space-y-12">
            {items.length === 0 ? (
                <div className="text-gray-400 text-center py-4">
                    담당 선생님이 없습니다.
                </div>
                ) : (
                items.map((item) => (
                    <div key={item.id} className="space-y-8 border-b border-gray-200 pb-10 last:border-none">
                        <div className="flex items-start space-x-6">
                            {item.file ? (
                                <img src={item.file} alt={item.name} className="w-32 h-32 rounded-full object-cover"/>                        
                            ) : (
                                <div className="w-32 h-32 rounded-full bg-gray-200 flex items-center justify-center mb-4 border-4 border-gray-100"><i className="ri-user-line text-4xl text-gray-400"></i></div>
                            )}
                            <div className="flex-1">
                                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                                    {item.name} 선생님
                                </h3>
                                <p className="text-purple-600 font-medium mb-4">
                                    {item.specialties.join(', ')}
                                </p>
                            </div>
                        </div>
                        {item.badge && (
                            <div>
                                <h4 className="text-xl font-bold text-gray-900 mb-3">수료배지</h4>
                                <img src={item.badge} alt={item.badge} className="max-w-[250px] rounded-xl"/>
                            </div>
                        )}
                        <div>
                            <h4 className="text-xl font-bold text-gray-900 mb-3">학력</h4>
                            <ul className="space-y-2">
                                {item.educations?.map((education, index) => (
                                    <li key={index} className="flex items-center space-x-3">
                                        <i className="ri-graduation-cap-fill text-purple-600 text-xl mt-1"></i>
                                        <span className="text-gray-700">{education}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-xl font-bold text-gray-900 mb-3">경력</h4>
                            <ul className="space-y-2">
                                {item.careers?.map((career, index) => (
                                    <li key={index} className="flex items-center space-x-3">
                                        <i className="ri-briefcase-fill text-purple-600 text-xl mt-1"></i>
                                        <span className="text-gray-700">{career}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-xl font-bold text-gray-900 mb-3">스케줄</h4>
                            <ScheduleSection classId={id} teacherId={item.id}/>
                        </div>
                    </div>
                )))
            }
        </div>
    );
};

export default TeacherSection;